import MultiSelect from "../../lib/multiSelectDropdown";
import clearPriceCheckerResult from "./clearPriceCheckerResult";
import { MODALITY_SELECT_SELECTOR } from "./modalitySelect";

type BookingFormWithMultiSelect = HTMLFormElement & {
  bodyPartMultiSelect?: {
    selectedValues: string[];
    options: { max?: number | null; onChange?: () => void };
    refresh: () => void;
    setValues: (values: string[]) => void;
  };
};

const initialiseBodyPartSelect = (form: Element) => {
  const hasMultiSelect =
    form.querySelector("select[data-multi-select-init='true']") ||
    (form as HTMLFormElement & { bodyPartMultiSelect?: unknown })
      .bodyPartMultiSelect;

  if (!hasMultiSelect) {
    return;
  }

  initialiseBodyPartMultiSelect(form);
};

export default initialiseBodyPartSelect;

const initialiseBodyPartMultiSelect = (form: Element) => {
  const modalitySelect = form.querySelector<HTMLSelectElement>(
    MODALITY_SELECT_SELECTOR
  );

  if (!modalitySelect) {
    return;
  }

  const bodyPartSelect = form.querySelector<HTMLSelectElement>(
    "select[data-multi-select-init='true']"
  );

  const formElement = form as BookingFormWithMultiSelect;

  if (!bodyPartSelect && !formElement.bodyPartMultiSelect) {
    return;
  }

  const continueBookingButton = form.querySelector<HTMLButtonElement>(
    "button[type='submit']"
  );

  const maxAllowedBodyParts = Number.parseInt(
    modalitySelect.selectedOptions[0]?.dataset.maxBodyParts ?? "1",
    10
  );

  let multiSelectInstance = formElement.bodyPartMultiSelect;

  if (multiSelectInstance) {
    multiSelectInstance.options.max = maxAllowedBodyParts;

    multiSelectInstance.options.onChange = () => {
      clearPriceCheckerResult(form);

      updateContinueBookingButtonState(
        continueBookingButton,
        multiSelectInstance?.selectedValues?.length || 0
      );
    };

    multiSelectInstance.refresh();

    updateContinueBookingButtonState(
      continueBookingButton,
      multiSelectInstance?.selectedValues?.length || 0
    );

    return;
  }

  multiSelectInstance = new MultiSelect(bodyPartSelect, {
    max: maxAllowedBodyParts,
    onChange: () => {
      clearPriceCheckerResult(form);

      updateContinueBookingButtonState(
        continueBookingButton,
        multiSelectInstance?.selectedValues?.length || 0
      );
    },
  });

  formElement.bodyPartMultiSelect = multiSelectInstance;

  updateContinueBookingButtonState(
    continueBookingButton,
    multiSelectInstance?.selectedValues?.length || 0
  );
};

const updateContinueBookingButtonState = (
  continueBookingButton?: HTMLButtonElement | null,
  selectedItemsCount = 0
) => {
  if (!continueBookingButton) {
    return;
  }

  continueBookingButton.disabled = selectedItemsCount === 0;
};
